<!--
  name : 김장호
  desc : 숫자 텍스트 필드
  date : 2021-05-13
-->
<template>
  <v-text-field
    class="inputH48_01 W100 H2row"
    v-model="dataValue"
    :value="value"
    @input="getData"
    :rules="rules"
    :placeholder="placeholder"
    :label="label"
    :suffix="suffix"
    :outlined="outlined"
  ></v-text-field>
</template>
<script>
export default {
  name: 'numberTextField',
  components: {
  },
  props: {
    value: {},
    rules: Array,
    label: String,
    placeholder: String,
    suffix: String,
    outlined: Boolean
  },
  filters: {
  },
  data () {
    return {
      data: '',
    }
  },
  computed: {
    dataValue: {
      get () {
        var value = this.data
        value = value.toString().replace(/,/gi, "")
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      },
      set (data) {
        this.data = data
      }
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    getData (data) {
      data = this.dataValue
      this.$emit('input', data)
    }
  }
}
</script>
<style scoped>
</style>